export default {
  DEPLOYER: '0xdDb108893104dE4E1C6d0E47c42237dB4E617ACc',
  MULTICALL: '0x5e227ad1969ea493b43f840cff78d08a6fc17796',
  FAUCET: '0x0000000000000000000000000000000000000000',
  MCD_DEPLOY: '0xbaa65281c2fa2baacb2cb550ba051525a480d3f4',
  MCD_GOV: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
  MCD_ADM: '0x9eF05f7F6deB616fd37aC3c959a2dDD25A54E4F5',
  MCD_VAT: '0x35d1b3f3d7966a1dfe207aa4514c12a259a0492b',
  MCD_JUG: '0x19c0976f590d67707e62397c87829d896dc0f1f1',
  MCD_CAT: '0x78f2c2af65126834c51822f56be0d7469d7a523e',
  MCD_VOW: '0xa950524441892a31ebddf91d3ceefa04bf454466',
  MCD_JOIN_DAI: '0x9759a6ac90977b93b58547b4a71c78317f391a28',
  MCD_FLAP: '0xdfe0fb1be2a52cdbf8fb962d5701d7fd0902db9f',
  MCD_FLOP: '0xbe00fe8dfd9c079f1e5f5ad7ae9a3ad2c571fcac',
  MCD_PAUSE: '0xbe286431454714f511008713973d3b053a2d38f3',
  MCD_PAUSE_PROXY: '0xbe8e3e3618f7474f8cb1d074a26affef007e98fb',
  MCD_GOV_ACTIONS: '0x4f5f0933158569c026d617337614d00ee6589b6e',
  MCD_DAI: '0x6b175474e89094c44da98b954eedeac495271d0f',
  MCD_SPOT: '0x65c79fcb50ca1594b025960e539ed7a9a6d434a3',
  MCD_POT: '0x197e90f9fad81970ba7976f33cbd77088e5d7cf7',
  MCD_END: '0xab14d3ce3f733cacb76ec2abe7d2fcb00c99f3d5',
  MCD_ESM: '0x0581a0abe32aae9b5f0f68defab77c6759100085',
  PROXY_ACTIONS: '0x82ecd135dce65fbc6dbdd0e4237e0af93ffd5038',
  PROXY_ACTIONS_END: '0x069b2fb501b6f16d1f5fe245b16f6993808f1008',
  PROXY_ACTIONS_DSR: '0x07ee93aeea0a36fff2a9b95dd22bd6049ee54f26',
  CDP_MANAGER: '0x5ef30b9986345249bc32d8928b7ee64de9435e39',
  GET_CDPS: '0x36a724bd100c39f0ea4d3a20f7097ee01a8ff573',
  PROXY_FACTORY: '0xa26e15c895efc0616177b7c1e7270a4c7d51c997',
  PROXY_REGISTRY: '0x4678f0a6958e4d2bc4f1baf7bc52e8f3564f3fe4',
  ETH: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  VAL_ETH: '0x81fe72b5a8d1a857d176c3e7d5bd2679a9b85763',
  PIP_ETH: '0x81fe72b5a8d1a857d176c3e7d5bd2679a9b85763',
  MCD_JOIN_ETH_A: '0x2f0b23f53734252bda2277357e97e1517d6b042a',
  MCD_FLIP_ETH_A: '0xd8a04f5412223f513dc55f839574430f5ec15531',
  BAT: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
  VAL_BAT: '0xb4eb54af9cc7882df0121d26c5b97e802915abe6',
  PIP_BAT: '0xb4eb54af9cc7882df0121d26c5b97e802915abe6',
  MCD_JOIN_BAT_A: '0x3d0b1912b66114d4096f48a8cee3a56c231772ca',
  MCD_FLIP_BAT_A: '0xaa745404d55f88c108a28c86abe7b5a1e7817c07',
  SAI: '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359',
  PIP_SAI: '0x54003dbf6ae6cba6ddae571ccdc34d834b44ab1e',
  MCD_JOIN_SAI: '0xad37fd42185ba63009177058208dd1be4b136e6b',
  MCD_FLIP_SAI: '0x5432b2f3c0dff95aa191c45e5cbd539e2820ae72',
  PROXY_PAUSE_ACTIONS: '0x6bda13d43b7edd6cafe1f70fb98b5d40f61a1370',
  PROXY_DEPLOYER: '0x1b93556ab8dccef01cd7823c617a6d340f53fb58',
  SAI_TUB: '0x448a5065aebb8e423f0896e6c5d525c040f59af3',
  MIGRATION: '0xc73e0383f3aff3215e6f04b0331d58cecf0ab849',
  MIGRATION_PROXY_ACTIONS: '0xe4b22d484958e582098a98229a24e8a43801b674'
};
